<div class="band" [class.band--compact]="compact()" role="search" aria-label="Filtre">
  <div class="band__row">
    <ng-content select="abook-filter-search" />

    @if (isCompact()) {
      <!-- Compact: every filter lives in the bottom sheet; the changed ones stay visible here. -->
      <button type="button" class="band__chip-button" (click)="openSheet()" aria-haspopup="dialog">
        <mat-icon aria-hidden="true">tune</mat-icon>
        Filtre
        @if (state().changedCount()) {
          ({{ state().changedCount() }})
        }
      </button>
      <div class="band__active-row">
        @if (filters(); as f) {
          <ng-container *ngTemplateOutlet="f.template" />
        }
        @if (moreFilters(); as m) {
          <ng-container *ngTemplateOutlet="m.template" />
        }
      </div>
    } @else {
      @if (filters(); as f) {
        <ng-container *ngTemplateOutlet="f.template" />
      }

      @if (moreFilters()) {
        <button
          type="button"
          class="band__chip-button"
          [class.is-open]="moreExpanded()"
          [attr.aria-expanded]="moreExpanded()"
          (click)="toggleMore()"
        >
          <mat-icon aria-hidden="true">tune</mat-icon>
          Flere filtre
          @if (moreChanged()) {
            ({{ moreChanged() }})
          }
        </button>
      }

      @if (state().anyChanged()) {
        @if (isNarrow()) {
          <button
            mat-icon-button
            type="button"
            class="band__reset-icon"
            matTooltip="Nulstil filtre"
            aria-label="Nulstil filtre"
            (click)="state().resetAll()"
          >
            <mat-icon>restart_alt</mat-icon>
          </button>
        } @else {
          <button mat-button type="button" class="band__reset" (click)="state().resetAll()">
            <mat-icon>restart_alt</mat-icon>
            Nulstil filtre
          </button>
        }
      }
    }
  </div>

  @if (!isCompact() && moreExpanded() && moreFilters(); as m) {
    <div class="band__more" role="group" aria-label="Flere filtre">
      <span class="band__more-divider">Flere filtre</span>
      <div class="band__row">
        <ng-container *ngTemplateOutlet="m.template" />
      </div>
    </div>
  }
</div>

<div class="band__progress" aria-hidden="true">
  @if (loading()) {
    <mat-progress-bar mode="indeterminate" />
  }
</div>

@if (state().notice(); as notice) {
  <div class="band__notice" role="status">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>{{ notice }}</span>
    <button mat-icon-button type="button" aria-label="Luk besked" (click)="state().dismissNotice()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<ng-template #sheet>
  <div class="abook-filter-sheet__content">
    <div class="abook-filter-sheet__header">
      <h2>Filtre</h2>
      @if (state().anyChanged()) {
        <button mat-button type="button" (click)="state().resetAll()">
          <mat-icon>restart_alt</mat-icon>
          Nulstil filtre
        </button>
      }
    </div>
    <div class="abook-filter-sheet__filters">
      @if (filters(); as f) {
        <ng-container *ngTemplateOutlet="f.template" />
      }
      @if (moreFilters(); as m) {
        <ng-container *ngTemplateOutlet="m.template" />
      }
    </div>
    <button mat-flat-button type="button" class="abook-filter-sheet__done" (click)="closeSheet()">
      {{ resultLabel() }}
    </button>
  </div>
</ng-template>
